import { Outlet, Navigate } from "react-router-dom";
import { Menu } from "lucide-react";

import { AdminSidebar } from "./AdminSidebar";
import { AdminTopbar } from "./AdminTopbar";
import { useAuthStore } from "@/store/auth-store";
import { useUIStore } from "@/store/ui-store"; // 🛠️ NEW

export function AdminLayout() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { toggleMobileMenu } = useUIStore(); // 🛠️ Pulling mobile menu toggle function

  if (!isAuthenticated) return <Navigate to="/login" replace />;
  const isAdmin = user && user.role !== "customer";
  if (!isAdmin) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen flex bg-surface-50">
      <AdminSidebar />
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-y-auto">
        
        {/* 💻 Desktop Topbar (Hidden on Mobile) */}
        <div className="hidden lg:block">
          <AdminTopbar />
        </div>

        {/* 📱 Mobile Topbar with Hamburger Menu (Visible on Mobile) */}
        <header className="lg:hidden h-14 bg-white border-b border-surface-200 flex items-center justify-between px-4 sticky top-0 z-30 shadow-sm shrink-0">
          <div className="flex items-center gap-2">
            <button 
              onClick={toggleMobileMenu} 
              className="p-1.5 -ml-1.5 text-surface-600 hover:bg-surface-100 rounded-md transition-colors"
            >
              <Menu className="h-6 w-6" />
            </button>
            <div className="font-bold text-surface-900 text-sm">Admin Console</div>
          </div>
          
          {/* Mobile Profile Icon */}
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-surface-700 to-surface-900 flex items-center justify-center text-white text-xs font-bold shadow-sm">
            {user?.full_name.charAt(0)}
          </div>
        </header>

        <main className="flex-1 p-4 lg:p-6 pb-12">
          <div className="max-w-[1600px] mx-auto animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}